<template>
  <div id='appbind' class=''>
    
    <div class='gPageBorder'>
      <div style='display:inline-block;width:calc(100% - 48px);height:100%;margin-bottom:0px;background:none;padding:0 0px 24px 24px'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{info ? info.launchername : ''}}</button>
        </div>
        <div style='height:30px;'>
          <table class='lcpush'>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{info? info.version : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_verTag')}}：</label>
                <label class='dt-word-main'>{{info? info.versioncode : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_package')}}：</label>
                <label class='dt-word-main'>{{info? info.packagename : ''}}</label>
              </td>
              
            </tr>
            
          </table>
        </div>
        <div style='min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_introl')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;'>
            <pre>{{info? info.launcherdesc : ''}}</pre>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id='abInfo'>
      <div style='width:120px;background:none;'>
        <img style='width:72px;height:72px;margin:16px 0 0 24px;' :src='avt'>
      </div>
      <div style='background:none;flex:1;display:flex;display:-webkit-flex;flex-direction:column;'>
        <div style='height:32px;background:none;display:flex;display:-webkit-flex;align-items:flex-end;'>
          <label style='font-size:14px;color:#5E6D82;'>{{$t('app_baseInfo')}}</label>
        </div>
        <div style='background:none;flex:1;display:flex;display:-webkit-flex;align-items:center'>
          <div class='diTag'>
            <div>
                <div>{{$t('app_appName')}}：{{info.appName}}</div>
                
                <div>{{$t('app_fileSize')}}：{{(info.appSize / 1000000).toFixed(2)}}M</div>
            </div>
          </div><div class='diTag'>
            <div>
              <div>{{$t('app_type')}}：{{info.appCategoryName}}</div>
              
              <div>{{$t('app_insType')}}：{{setInstallType(info.appInstallType)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div id='' class='gPageBorder gTopMg'>
      <p class='gCtColor gPTitle' style=''>{{$t('app_pushDevice')}}</p>

      <el-button class='gSgLeftBtn' @click='addBind'>{{$t('app_addPush')}}</el-button>

      <el-button @click='allUnbind()' style=''>{{$t('app_bcrecov')}} ({{sNum}})</el-button>

      
     
      <el-table
      class='gTopMg'
      ref="multipleTable"
      id='dpTable'
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          align='center'
          width="55">
        </el-table-column>
        <el-table-column
          prop="terminalName"
          align='center'
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_deviceNo')"
          width="">
        </el-table-column>
        <el-table-column
          prop="createTime"
          align='center'
          :label="$t('app_pushTime')"
          width='175'>
        </el-table-column>
        <el-table-column
          align='center'
          prop="distributorName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='106'>
          <template slot-scope='scope'>
            <!-- <el-button v-show="scope.row.isUpdate === '0'" @click='updateDv(scope.row)' type=text>{{$t('app_update')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_update')" placement="top">
              <el-button  v-show="scope.row.isUpdate === '0'" @click='updateDv(scope.row)' type=text><i class="fa fa-refresh" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button @click='bindOperate(scope.row)' type=text>{{$t('app_recov')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_recov')" placement="top">
              <el-button  @click='bindOperate(scope.row)' type=text><i class="fa fa-history" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      
      <div class="gPgDiv">

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
 
  .lcpush td{width:25%;}
  #abInfo p{height:30px;}
  #abInfo td{height:30px;background:none;}
  #abInfo{background: none;width:50%;border:1px solid #EAEEFA;border-radius:7px;height:105px;display:flex;display:-webkit-flex;overflow:hidden;}
  .diTag{background:no1ne;height:52px;width:50%;display:inline-block;}
    .diTag div{width:93%;height:100%;;background:none;display:flex;display:-webkit-flex;flex-direction:column;overflow:hidden;font-size:14px;color:#495769; text-overflow:ellipsis;white-space:nowrap;}
</style>

<script>
  export default{
    data () {
      return {
        mechanismId: window.localStorage['mechanismId'],
        tableData: [],
        info: '',
        total: 0,
        row: this.$gRow,
        page: 1,
        list: [],
        sNum: 0
      }
    },
    components: {},
    computed: {
      avt () {
        // return this.$host + this.info.appSmallIcon
        return this.$urls.prefix + this.info.appBigIcon
      },
      avtStyle () {
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + this.avt + ')'
      },
      index () {
        return this.$getWPage('appMarketPushPage')
      }
    },
    methods: {
      updateDv (row) {
        // console.log(this.info)
        this.loading = 1
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminialId, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds(this.page)
            }
          }, () => {
            this.loading = 0
          })
        } else {
          this.$bindApp1(this.mechanismId, row.terminalNo, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds(this.page)
            }
          }, () => {
            this.loading = 0
          })
        }
        
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      handleSelectionChange (list) {
        // console.log(list)
        this.sNum = list.length
        this.list = list
      },
      allUnbind () {
        //alert()
        //return 
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var tNos = ''
          var pkg = ''
          this.list.forEach((vl) => {
            tNos += vl.terminalNo + ','
            pkg = vl.packagename
          })
          tNos = tNos.substring(0, tNos.length - 1)
          // console.log(ids)
          if (!tNos) {
            this.$message($t('app_oneDeviceMust'))
            return 
          }
          this.unbindReq(tNos, pkg)
        }, '')
        
      },
      bindOperate (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           //console.log(row)
          this.unbindReq(row.terminalNo, row.packagename)
        }, '')
      },
      unbindReq (tNo, pkg) {
        this.loading = 1
        this.$resetLauncher(pkg, tNo, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.getBinds(this.page)
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
        
      },
      addBind () {
        ///launch-push-ter
        //this.$router.push({name: this.$t('menu.appManageSub.appBind')})
        this.$setWObj('launcherBind', this.info)
        this.$router.push({path: '/launch-push/launch-push-ter'})
      },
      getBinds (page) {
        this.loading = 1
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
        this.$getLauncherDevices(page, this.$gRow, this.info.launcherid, localStorage.mechanismId, this.info.packagename, (res) => {
          this.loading = 0
          if (res.status === 200) {
            console.log(res)
            this.tableData = res.data
            this.total = res.total
            this.page = page
            
            //this.tableData = [{}]
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      },
      pageSelect (index) {
        this.getBinds(index)
        this.$setWPage('appMarketPushPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getBinds(this.index)
      }
    },
    mounted () {
      var obj = this.$getWObj().launcherPush
      this.info = obj
      console.log('info', this.info)
      this.getBinds(this.page)
    }
  }
</script>



// WEBPACK FOOTER //
// push.vue?0b25d655